import api from '../../services/api'

export default {
  state: {
    register: {}
  },
  getters: {
    register (state) {
      return state.register
    }
  },
  mutations: {
    setRegister (state, register) {
      state.register = register
    },
    updateRegister (state, register) {
      state.register = register
    },
    clearRegister (state) {
      state.register.id = ''
      state.register.mac = ''
      state.register.type = ''
      state.register.token = ''
    }
  },
  actions: {
    fetchRegister ({ commit }, mac) {
      commit('clearError')
      commit('setLoading', true)
      commit('clearRegister')

      return new Promise((resolve, reject) => {
        api.get(`registers?mac=${mac}`)
          .then(result => {
            commit('setRegister', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    },
    updateRegister ({ commit }, updatedRegister) {
      commit('clearError')
      commit('setLoading', true)

      return new Promise((resolve, reject) => {
        api.put(`registers/${updatedRegister.id}`, updatedRegister)
          .then(result => {
            commit('updateRegister', result.data)
            resolve(result.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.error)
            } catch (e) {
              reject(err)
            }
          })
          .finally(() => commit('setLoading', false))
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/register/index.js